import React, { useEffect } from 'react';

const StrainDetails = ({ strain, fetchStrainDetails, details }) => {
// Fetch strain details when the strain object changes
useEffect(() => {
if (strain && strain.id && strain.brid) {
fetchStrainDetails(strain.id, strain.brid);
}
}, [strain, fetchStrainDetails]);

// Function to format strain data as HTML
const formatStrainDataAsHTML = (data) => {

let htmlContent = `<h3>${data.id}</h3>`;

htmlContent += `<img src="${data.brinfo.pic}" alt="${data.id}" />`;

if (data.parents && data.parents.strains.bbb) {
htmlContent += `<p><strong>Parents:</strong> ${data.parents.strains.aaa?.id || 'N/A'}</p>`;
htmlContent += `<p>${data.parents.strains.bbb?.id || 'N/A'}</p>`;
}

if (data.brinfo.link) {
htmlContent += '<h4>Link to Genetics Company</h4><ul>';
htmlContent += `<li><a href="${data.brinfo.link}" target="_blank" rel="noopener noreferrer">${data.brinfo.id}</a></li>`;
htmlContent += '</ul>';
}

if (data.pics) {
htmlContent += '<h4>Photos</h4>';
data.pics.forEach(pic => {
htmlContent += `<img src="${pic.url}" alt="${pic.title}" style="max-width: 100%; margin-bottom: 10px;">`;
});
}

// Additional strain info
htmlContent += `<p><strong>Strain ID:</strong> ${data.id}</p>`;
htmlContent += `<p><strong>Breeder:</strong> ${data.brinfo.id}</p>`;
htmlContent += `<p><strong>About the Breeder:</strong> ${data.brinfo.description}</p>`;
htmlContent += `<p><strong>Species:</strong> ${data.brinfo.type}</p>`;
htmlContent += `<p><strong>CBD:</strong> ${data.brinfo.cbd}</p>`;
htmlContent += `<p><strong>Auto?:</strong> ${data.brinfo.flowering.auto}</p>`;
htmlContent += `<p><strong># of days:</strong> ${data.brinfo.flowering.days}</p>`;
htmlContent += `<p><strong>info:</strong> ${data.brinfo.flowering.info}</p>`;
htmlContent += `<p><strong>Strain Info:</strong> ${data.brinfo.descr}</p>`;
htmlContent += `<p><strong>ParentA:</strong> ${data.parents.strains.aaa.id}</p>`;
if (data.parents.strains.bbb) {
htmlContent += `<p><strong>ParentB:</strong> ${data.parents.strains.bbb.id}</p>`;
}

return htmlContent;
};

// Render Loading or Strain Details
if (!details) {
return <div><img src="https://marsto100.dreamhosters.com/merk/dabs-circle-vector.svg" height="50px" /></div>;
} else {
return (
<div className="results" id="results" dangerouslySetInnerHTML={{ __html: formatStrainDataAsHTML(details) }}></div>
);
}
};

export default StrainDetails;
